export default {
  title: "Configuration",
  description: "Manager general settings",
  fixed_value: "Fixed value",
  no_future_values: "There are no future values",
  current_value: "Current value",
  current_value_lei: "Valoare curenta Lei",
  current_euro_value: "Valoare curenta EUR",
  new_value: "New value",
  new_value_lei: "Future value Lei",
  new_euro_value: "Future value EUR",
  parameter_name: "Parameter name",
  percent: "percent",
  tooltips: {
    current_value_info_bnr: "The value in RON will be calculated automatically at NBR exchange rate",
    euro_exchange_checkbox: "If this checkbox is checked, the value in EUR and the equivalent in RON will be calculated " +
        "automatically at NBR exchange rate. If not checked, only the value entered in RON will be considered",
  },
  table: {
    new_config: "Add new configuration",
    edit_config: "Change configuration",
    current_value: "Current value",
    current_value_eur: "Current EUR value",
    future_value: "Future value",
    future_value_eur: "Future EUR value",
  }
}
